import { authActions } from './auth-slice';
import { fetchMyProfile } from '../../lib/api';
import { getData } from '../common-actions';

import * as constants from "../../constants/authConstants";

export const getMyProfile = (token, signal) => {
  return getData({
    token: token,
    actions: authActions,
    fetchFn: (token) => fetchMyProfile(token, signal),
    dataKey: "profile",
    name: "get profile",
    setFunctionName: "setProfile",
  });

  /*
  return async (dispatch) => {

    //const {sendRequest, status, skills, error} = useHttp(fetchskills);
    //const {token} = useSelector(state => state.auth);

    const myUser = await fetchMyProfile(token);

    dispatch(
        authActions.setProfile({profile: myUser})
    );
  };*/
};

export const login = (token, expiresAt) => {
  return (dispatch) => {
    if (token) {
      window.localStorage.setItem(constants.KEY_TOKEN, token);
    }
    
    if (expiresAt) {
      window.localStorage.setItem(constants.KEY_TOKEN_EXPIRES_AT, expiresAt);
    }

    console.log(`Token: ${token}`);
    dispatch(authActions.setAuth({token: token, expiresAt: expiresAt.toString()}));
  }
}

export const logout = (doRedirectLogout) => {
  return (dispatch) => {
    localStorage.removeItem(constants.KEY_TOKEN);
    localStorage.removeItem(constants.KEY_TOKEN_EXPIRES_AT);
    localStorage.removeItem(constants.KEY_REDIRECT_TO_AFTER_LOGIN);
    dispatch(authActions.setAuth({token: null, doRedirectLogout: !!doRedirectLogout}));
  }
}